import React, { useContext } from 'react'
import { Switch } from 'react-router-dom'

import { PrivateRoutes } from './Index'

import PharmaciesFiltersContextProvider from '../context/PharmaciesFiltersContext'
import PharmaciesDetailsFiltersContextProvider from '../context/PharmaciesDetailsFiltersContext'
import DailyMonitoringFiltersContextProvider from '../context/DailyMonitoringFiltersContext'
import LossesFiltersContextProvider from '../context/LossesFiltersContext'
import { AuthContext } from '../context/AuthContext'

import DailyMonitoringOverview from '../pages/Orders/Index'
import Pharmacies from '../pages/Orders/Pharmacies'
import DetailedPharmacy from '../pages/Orders/DetailedPharmacy'
import Losses from '../pages/Orders/Losses'

export default function OrdersRoutes (): JSX.Element {
  const { auth } = useContext(AuthContext)
  return (
    <PharmaciesFiltersContextProvider>
      <PharmaciesDetailsFiltersContextProvider>
        <DailyMonitoringFiltersContextProvider>
          <LossesFiltersContextProvider>
            <Switch>
              <PrivateRoutes path="/pedidos/overview" component={DailyMonitoringOverview} auth={auth} />
              <PrivateRoutes path="/pedidos/farmacies" component={Pharmacies} auth={auth} />
              <PrivateRoutes path="/pedidos/detailed-pharmacy" component={DetailedPharmacy} auth={auth} />
              <PrivateRoutes path="/pedidos/perdas" component={Losses} auth={auth} />
            </Switch>
          </LossesFiltersContextProvider>
        </DailyMonitoringFiltersContextProvider>
      </PharmaciesDetailsFiltersContextProvider>
    </PharmaciesFiltersContextProvider>
  )
}
